import type { CrewMember } from "@/mocks/admin/crew";

const DAYS: ("M" | "T" | "W" | "Th" | "F" | "Sa" | "Su")[] = ["M", "T", "W", "Th", "F", "Sa", "Su"];
const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// Mock weekly schedule (mock — same for any crew member for now)
const weeklySchedule: Record<string, { time: string; project: string; label: string } | null> = {
  Mon: { time: "07:30 – 13:30", project: "MV-2041", label: "Sullivan move" },
  Tue: { time: "08:00 – 16:00", project: "MV-2046", label: "Mendez 2BR" },
  Wed: null,
  Thu: { time: "06:00 – 14:00", project: "MV-2048", label: "Genesis warehouse" },
  Fri: { time: "09:00 – 15:00", project: "MV-2050", label: "Hartwell house" },
  Sat: null,
  Sun: null,
};

export default function AvailabilityCalendar({ member }: { member: CrewMember }) {
  return (
    <div className="bg-white border border-ink-100 rounded-lg">
      <div className="px-5 pt-5 pb-4 border-b border-ink-100 flex items-center justify-between">
        <div>
          <h3 className="font-display text-base font-bold text-ink-900">Weekly Schedule</h3>
          <p className="text-[11px] text-ink-500 mt-0.5">Jun 01 – Jun 07, 2026</p>
        </div>
        <div className="flex items-center gap-1">
          <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-cream-100 text-ink-500 cursor-pointer">
            <i className="ri-arrow-left-s-line"></i>
          </button>
          <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-cream-100 text-ink-500 cursor-pointer">
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>

      <div className="p-5">
        <div className="grid grid-cols-7 gap-2">
          {DAYS.map((d, idx) => {
            const label = DAY_LABELS[idx];
            const av = member.availability.includes(d);
            const sched = weeklySchedule[label];
            return (
              <div
                key={d}
                className={`rounded-md p-3 min-h-[120px] flex flex-col border ${
                  av
                    ? sched
                      ? "border-brand-200 bg-brand-50/50"
                      : "border-ink-100 bg-white"
                    : "border-ink-100 bg-cream-100"
                }`}
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="text-[10px] font-bold uppercase tracking-wider text-ink-500">
                    {label}
                  </div>
                  <div className="font-display text-sm font-bold text-ink-900">
                    {idx + 1}
                  </div>
                </div>
                {!av ? (
                  <div className="flex-1 flex items-center justify-center text-[10px] text-ink-400 font-semibold uppercase tracking-wider">
                    Off
                  </div>
                ) : sched ? (
                  <div className="space-y-1.5">
                    <div className="text-[10px] font-bold font-mono text-brand-700">
                      {sched.project}
                    </div>
                    <div className="text-[11px] font-semibold text-ink-900 leading-tight">
                      {sched.label}
                    </div>
                    <div className="text-[10px] text-ink-500 leading-tight">{sched.time}</div>
                  </div>
                ) : (
                  <div className="flex-1 flex items-center justify-center">
                    <span className="text-[10px] font-semibold text-emerald-700 bg-emerald-50 px-2 py-1 rounded-full">
                      Available
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}